export default __webpack_public_path__ + "de5ceb4c4d77616cb0c2654b2423747f.png";